import { Box } from '@mui/material';
import { t } from 'i18next';
import { StepCustom } from './types';

export const getMainTour = (): StepCustom[] => [
    {
        title: <Box className="tooltip-title">{t('web_app.product_tour.intake_note.label')}</Box>,
        target: '.intake-notes-editor-content',
        content: t('web_app.product_tour.intake_note.body'),
        disableBeacon: true,
        id: 'full-tour',
        placement: 'top-start',
        locale: {
            next: t('workflow.next'),
        },
    },
    {
        title: <Box className="tooltip-title">{t('web_app.product_tour.generate_btn.label')}</Box>,
        target: '.action-buttons-main',
        id: 'full-tour',
        content: t('web_app.product_tour.generate_btn.body'),
        locale: {
            next: t('workflow.next'),
        },
    },
    {
        title: (
            <Box className="tooltip-title">{t('web_app.product_tour.advanced_settings.label')}</Box>
        ),
        target: '.action-buttons-settings',
        id: 'full-tour',
        content: t('web_app.product_tour.advanced_settings.body'),
        locale: {
            next: t('workflow.next'),
        },
    },
    // {
    //     title: <Box className="tooltip-title">{t('web_app.product_tour.edit_btn.label')}</Box>,
    //     target: '.right-sidebar-box button',
    //     content: t('web_app.product_tour.edit_btn.body'),
    //     placement: 'left',
    //     id: 'full-tour',
    //     locale: {
    //         next: t('workflow.next'),
    //     },
    //     // offset: 550,
    // },
    {
        title: <Box className="tooltip-title">{t('web_app.product_tour.history.label')}</Box>,
        target: '.left-sidebar',
        id: 'full-tour',
        content: t('web_app.product_tour.history.body'),
        locale: {
            next: t('workflow.next'),
        },
    },
    {
        title: <Box className="tooltip-title">{t('web_app.product_tour.all_done.label')}</Box>,
        target: '.job-generator',
        id: 'full-tour',
        placement: 'center',
        content: t('web_app.product_tour.all_done.body'),
        styles: {
            tooltip: {
                background: '#4A90E2',
                color: 'white',
            },
            buttonNext: {
                background: '#4A90E2',
                color: 'white',
            },
        },
        locale: {
            last: t('web_app.product_tour.all_done.btn'),
        },
    },
];
export const getGenerateVersionsTour = (): StepCustom[] => [
    {
        title: (
            <Box className="tooltip-title">
                <Box className="tooltip-title-new">{t('web_app.new')}</Box>
                {t('web_app.product_tour.generate_versionns.generate.label')}
            </Box>
        ),
        target: '.int-nots-btn',
        content: t('web_app.product_tour.generate_versionns.generate.content'),
        disableBeacon: true,
        id: 'generate-btn-tour',
        styles: {
            tooltip: {
                alignItems: 'stretch',
            },
            tooltipContent: {
                padding: '0px',
            },
        },
        locale: {
            next: t('workflow.next'),
        },
    },
    {
        title: (
            <Box className="tooltip-title">
                {' '}
                <Box className="tooltip-title-new">{t('web_app.new')}</Box>
                {t('web_app.product_tour.generate_versionns.regenerate.label')}
            </Box>
        ),
        target: '.regenerate-btn',
        content: t('web_app.product_tour.generate_versionns.regenerate.content'),
        disableBeacon: true,
        id: 'generate-btn-tour',
        styles: {
            tooltip: {
                alignItems: 'stretch',
            },
            tooltipContent: {
                padding: '0px',
            },
        },
        locale: {
            last: t('web_app.product_tour_page.got_it'),
        },
    },
];
